const borderAndShadow = {
  borderRadius: 0,
  boxShadow: '0 4px 6px 0 hsla(0, 0%, 0%, 0.2) !important',
};

// primary | main = blue, secondary = orange
// secondary | main = 'grey
const PoppinsSemiBold = {
  fontFamily: 'PoppinsSemiBold',
  fontWeight: 600,
};

const MadaRegular = {
  fontFamily: 'MadaRegular',
  fontWeight: 400,
};

const MadaMedium = {
  fontFamily: 'MadaMedium',
  fontWeight: 500,
};

const MadaBold = {
  fontFamily: 'MadaBold',
  fontWeight: 700,
};
const PrimaryTextColor = '#4B4B4B';
export default {
  typography: {
    fontFamily: 'MadaRegular',
    letterSpacing: 0,
    h1: {
      fontSize: '2.625rem',
      lineHeight: '1.35',
      ...PoppinsSemiBold,
    },
    h2: {
      fontSize: '2.313rem',
      lineHeight: '1.35',
      ...PoppinsSemiBold,
    },
    h3: {
      fontSize: '2rem',
      lineHeight: '1.41',
      ...PoppinsSemiBold,
    },
    h4: {
      fontSize: '1.688rem',
      lineHeight: '1.37',
      ...PoppinsSemiBold,
    },
    h5: {
      fontSize: '1.375rem',
      lineHeight: '1.32',
      ...PoppinsSemiBold,
    },
    h6: {
      fontSize: '1.063rem',
      lineHeight: '1.23',
      ...PoppinsSemiBold,
    },
    button: {
      fontSize: '0.875rem',
      lineHeight: '1.21',
      fontFamily: 'MadaBold',
      fontWeight: 700,
    },
    subtitle1: {
      // p bold in sketch
      fontSize: '1.063rem',
      lineHeight: '1.35',
      ...MadaBold,
    },
    subtitle2: {
      // p large bold in sketch
      fontSize: '1.25rem',
      lineHeight: '1.5',
      ...MadaBold,
    },
    body1: {
      // p large in sketch
      fontSize: '1.25rem',
      lineHeight: '1.5',
      ...MadaRegular,
    },
    body2: {
      // p in sketch
      fontSize: '1.0625rem',
      lineHeight: '1.35',
      ...MadaRegular,
    },
    caption: {
      // p.small.bold in sketch
      fontSize: '0.875rem',
      lineHeight: '1.57',
      fontFamily: 'MadaBold',
    },
    overline: {
      // p.small in sketch
      fontSize: '0.875rem',
      lineHeight: '1.57',
      textTransform: 'none',
      ...MadaRegular,
    },
    pxSmall: {
      fontSize: '0.75rem',
      lineHeight: '1.5',
      ...MadaRegular,
    },
    pSmallBold: {
      // p.small.bold in sketch
      fontSize: '0.875rem',
      lineHeight: '1.57',
      fontFamily: 'MadaBold',
    },
    pBold: {
      fontSize: '1.063rem',
      lineHeight: '1.35',
      ...MadaMedium,
    },
    pxSmallBold: {
      fontSize: '0.75rem',
      lineHeight: '1.5',
      ...MadaMedium,
    },
    h7: {
      lineHeight: 1.4,
      fontSize: '1.05em',
      ...PoppinsSemiBold,
    },
  },
  palette: {
    primary: {
      main: '#01619B', // blue
      secondary: '#FFA900', // orange
      light: '#ECF2F5', // gray light
      contrastText: PrimaryTextColor, // charcoal
    },
    secondary: {
      main: '#EDEEF7',
    },
    text: {
      primary: PrimaryTextColor, // typography black
      secondary: '#01619B', // typography primary
      disabled: '#505050', // typography muted
      hint: '#F8AC24', // typography secondary
      white: '#fff',
    },
  },
  overrides: {
    MuiCard: {
      root: borderAndShadow,
    },
    MuiDialogContent: {
      root: {
        borderRadius: 0,
      },
    },
    MuiPaper: {
      root: {
        borderRadius: '0 !important',
      },
    },
    MuiButton: {
      root: {
        borderRadius: 0,
      },
    },
    MuiFormLabel: {
      root: {
        color: PrimaryTextColor,
      },
    },
  },
};
